import React from 'react';
import axios from 'axios';
import {GET_FICHES_TYPE} from "../../api/Api";

export default function useFicheTypeData(){

    const [isLoading,setIsLoading] = React.useState(false);
    const [fiches,setFiches] = React.useState([]);

    React.useEffect(
        () => {

            setIsLoading(true)

            axios
                .get(
                    GET_FICHES_TYPE
                ).then(
                ({data}) => {

                     setFiches(data);

                }
            ).finally(
                ()=>{
                    setIsLoading(false);
                }
            )

        }, []
    );

    return [isLoading,fiches]
}